export const OrdersSnDisabilityFilter = [
  { label: '全部', val: '' },
  { label: '失能', val: '1' },
  { label: '半失能', val: '2' }
]

// 新项目订单状态（列表/详情 order_status）
export const OrdersSnStatus = [
  { label: '未分配', val: 10 },
  { label: '待服务', val: 20 },
  { label: '服务中', val: 30 },
  { label: '已完成', val: 60 }
]

/** 详情 userInfo.result */
export const OrdersSnUserHospitalResult = [
  { label: '住院中', val: 1 },
  { label: '出院', val: 2 }
]

// 1待服务 2服务中 3已完成 4已取消
export const OrderStatus = [
  { label: '待服务', val: 1 },
  { label: '服务中', val: 2 },
  { label: '已完成', val: 3 },
  { label: '已取消', val: 4 }
]
export const OrderAllStatus = [
  { label: '待支付', val: 1 },
  { label: '已失效', val: 2 },
  { label: '待接单', val: 10 },
  { label: '待服务', val: 20 },
  { label: '服务中', val: 30 },
  { label: '待处理', val: 40 },
  { label: '已完成', val: 60 },
  { label: '已取消', val: 50 },
  { label: '拒绝退款', val: 41 }
]
export const OrderPayTypeStatus = [
  { label: '支付', val: 1 },
  { label: '退款', val: 2 }
]

export const OrderPayTypes = [
  { label: '微信', val: 0 },
  { label: '支付宝', val: 1 }
]
// 1视力 2智力 3听力 4言语 5肢体 6精神
export const DisabilityTypes = [
  { label: '视力', val: '1' },
  { label: '智力', val: '2' },
  { label: '听力', val: '3' },
  { label: '言语', val: '4' },
  { label: '肢体', val: '5' },
  { label: '精神', val: '6' }
]
